import axios from './axios';

export const getHeader = () => {
    const header = {
        headers: {
            Auth: 'Basic Auth',
            Accept: "application/json",
            'X-AISAFETYGENIE-API-KEY': 'Y2FsZW9hZG1pbjpjYWxlb0BhZG1pbg==',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
        }
    }
    return header;
}

export const getAuthHeader = () => {
    const token = 'Bearer ' + localStorage.getItem('useToken');
    const header = {
        headers: {
            Authorization: token,
            Accept: 'application/json',
            'X-AISAFETYGENIE-API-KEY': 'Y2FsZW9hZG1pbjpjYWxlb0BhZG1pbg==',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
            "Content-Type": "application/json"
        }
    }
    return header;
}
export const getAuthHeaderBlob = () => {
    const token = 'Bearer ' + localStorage.getItem('useToken');
    const header = {
        headers: {
            Authorization: token,
            Accept: 'application/json',
            'X-AISAFETYGENIE-API-KEY': 'Y2FsZW9hZG1pbjpjYWxlb0BhZG1pbg==',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
            "Content-Type": "application/json"
        },
        responseType: 'blob'
    }
    return header;
}


export const getAuthHeaderFM = () => {
    const token = 'Bearer ' + localStorage.getItem('useToken');
    const header = {
        headers: {
            Authorization: token,
            'X-AISAFETYGENIE-API-KEY': 'Y2FsZW9hZG1pbjpjYWxlb0BhZG1pbg==',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
        }
    }
    return header;
}

export const postLogin = async (postdata) => {
    return await axios.post('/login', postdata, getHeader()).then(res => {
        return res;
    })
}

export const postForgotPassword = async (postdata) => {
    return await axios.post('/forgotPassword', postdata, getHeader()).then(res => {
        return res;
    })
}

export const postForgotPasswordVerify = async (postdata) => {
    return await axios.post('/forgotPasswordVerify', postdata, getHeader()).then(res => {
        return res;
    })
}

export const getAirpotList = async () => {
    return await axios.get('/dropdown/airpot', getAuthHeader()).then(res => {
        return res;
    })
}

export const getAircraftRegistrationMaster = async () => {
    return await axios.get('/dropdown/aircraft-registration-masters', getAuthHeader()).then(res => {
        return res;
    })
}

export const getPassengerImpactMainMaster = async () => {
    return await axios.get('/dropdown/passenger-impact-main-masters', getAuthHeader()).then(res => {
        return res;
    })
}

export const getPassengerImpactSubMaster = async () => {
    return await axios.get('/dropdown/passenger-impact-sub-field_masters', getAuthHeader()).then(res => {
        return res;
    })
}

export const getStatusList = async () => {
    return await axios.get('dropdown/status', getAuthHeader()).then(res => {
        return res;
    })
}

export const postIncidentListing = async (postdata) => {
    return await axios.post('/incident_listing', postdata, getAuthHeaderFM()).then(res => {
        return res;
    })
}

//Profile
export const getProfile = async () => {
    return await axios.get('/user/profile', getAuthHeader()).then(res => {
        return res;
    })
}

export const postProfile = async (postdata) => {
    return await axios.post('/user/profile_update', postdata, getAuthHeaderFM()).then(res => {
        return res;
    })
}

export const postSendOtp = async (postdata) => {
    return await axios.post('user/send_otp', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


export const postChangePassword = async (postdata) => {
    return await axios.post('/user/changePassword', postdata, getAuthHeader()).then(res => {
        return res;
    })
}





//Forms

export const getSeverity = async () => {
    return await axios.get('/dropdown/severity', getAuthHeader()).then(res => {
        return res;
    })
}

export const getLikeliHood = async () => {
    return await axios.get('/dropdown/likelihood', getAuthHeader()).then(res => {
        return res;
    })
}

export const getDepartmentList = async () => {
    return await axios.get('/dropdown/department', getAuthHeader()).then(res => {
        return res;
    })
}

export const getAirportMaster = async () => {
    return await axios.get('/dropdown/all-airport-master', getAuthHeader()).then(res => {
        return res;
    })
}

export const getRiskAsessment = async () => {
    return await axios.get('/dropdown/risk-assessment', getAuthHeader()).then(res => {
        return res;
    })
}

export const getCategoriesList = async () => {
    return await axios.get('/categories/list', getAuthHeader()).then(res => {
        return res;
    })
}

// staff & designations
export const getStaff = async () => {
    return await axios.get('/dropdown/staff', getAuthHeader()).then(res => {
        return res;
    })
}
export const postDesignations = async (postdata) => {
    return await axios.post('/dropdown/designations', postdata, getAuthHeader()).then(res => {
        return res;
    })
}



export const postGeneralForms = async (postdata) => {
    return await axios.post('/incident', postdata, getAuthHeaderFM()).then(res => {
        return res;
    })
}

export const postStatementFormStore = async (postdata) => {
    return await axios.post('/statement-form/store', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postWhyDidItHappen = async (postdata) => {
    return await axios.post('/why-did-happen/store', postdata, getAuthHeader()).then(res => {
        return res;
    })
}


export const postWhoWasInvolveStore = async (postdata) => {
    return await axios.post('/who-was-involve/store', postdata, getAuthHeaderFM()).then(res => {
        return res;
    })
}

export const postVerificationAndMonitoring = async (postdata) => {
    return await axios.post('/verification-monitoring/store', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postPreventingActionPlan = async (postdata) => {
    return await axios.post('/prevent-action-plan/store', postdata, getAuthHeader()).then(res => {
        return res;
    })
}




export const postIncidentViewDetail = async (postdata) => {
    return await axios.post('/incident-view-detail', postdata, getAuthHeader()).then(res => {
        return res;
    })
}



export const postWhatOccurredStore = async (postdata) => {
    return await axios.post('/what-occurred/store', postdata, getAuthHeaderFM()).then(res => {
        return res;
    })
}


export const getAircarftType = async () => {
    return await axios.get('/dropdown/aircraft-type', getAuthHeader()).then(res => {
        return res;
    })
}
export const getAirLineOperators = async () => {
    return await axios.get('/dropdown/airline', getAuthHeader()).then(res => {
        return res;
    })
}


export const getHazardTypes = async () => {
    return await axios.get('/dropdown/hazardtype', getAuthHeader()).then(res => {
        return res;
    })
}

export const postImageAnalyze = async (postdata) => {
    return await axios.post('/image-analyze/get-generate-report', postdata, getAuthHeaderFM()).then(res => {
        return res;
    })
}

export const postUpdateDescription = async (postdata) => {
    return await axios.post('/update-description', postdata, getAuthHeaderFM()).then(res => {
        return res;
    })
}

export const postIncidentDepartmentAactionTaken = async (postdata) => {
    return await axios.post('/incident-department/action-taken', postdata, getAuthHeaderFM()).then(res => {
        return res;
    })
}

export const postRiskMatrixUpdate = async (postdata) => {
    return await axios.post('/risk-matrix/update', postdata, getAuthHeader()).then(res => {
        return res;
    })
}

export const postCorrectiveActionPlanUpdate = async (postdata) => {
    return await axios.post('/corrective-action-plan/update', postdata, getAuthHeader()).then(res => {
        return res;
    })
}







export const postSummaryReportGeneratePdf = async (postdata) => {
    return await axios.post('/summary-report/report', postdata, getAuthHeaderBlob()).then(res => {
        return res;
    })
}

export const postFinalReportPdf = async (postdata) => {
    return await axios.post('/summary-report/finalreport', postdata, getAuthHeaderBlob()).then(res => {
        return res;
    })
}

